import { render } from "./NcrmContractAddProductAction.vue?vue&type=template&id=960334d2"
import script from "./NcrmContractAddProductAction.vue?vue&type=script&lang=js"
export * from "./NcrmContractAddProductAction.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__